import {
  underDevelopmentModules,
  devRouteName,
} from "@/config/underDevelopmentModules.js";

const UnderDevelopmentDashboard = () =>
  import("@/views/modules/underDevelopment/Dashboard");

// PDEV Router  - ماژول‌های در حال توسعه ------------------------------------
// برای هر ماژولی که در منو وجود دارد ولی صفحه‌ای برایش ساخته نشده،
// یک مسیر اختصاصی ساخته می‌شود تا کاربر به اشتباه وارد ماژول دیگری نشود.
let routeItems = {
  path: "PDEV",
  name: "PDEV",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: underDevelopmentModules.map((item) => ({
    path: item.path,
    name: devRouteName(item),
    meta: {
      label: item.title,
      requiresAuth: true,
      underDevelopment: item.key,
    },
    component: UnderDevelopmentDashboard,
  })),
};

export default routeItems;
